/*
 * @Deccription: 外链和预览的所有的路由规划
 * @Author: zjg
 * @Date: 2019-12-06 14:45:50
 * @LastEditTime: 2020-04-29 18:16:44
 */
import Box from 'components/page/box.vue'
import ApproveBox from 'components/page/approveBox.vue'
import Verbox from 'components/page/verbox.vue'
import Smbox from 'components/page/smbox.vue'
import Linkbox from 'components/page/linkbox.vue'
import ThirdPartyLinkbox from 'components/page/thirdPartylinkbox.vue'
import Linkpreviewbox from 'components/page/linkPreviewBox.vue'
import ApproveFile from 'components/page/ApproveFile.vue'
import FerryFile from 'components/page/FerryFile.vue'
import Icondict from 'components/icondict.vue'
import PreLogin from 'components/page/preLogin'
import Login from 'components/login'

const routes = [
  // 外链相关vvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
  // 外链文件平内文件预览，与普能文预览一样，目前与正常分离，后期整合
  // 通用的外链文件预览
  {
    path: '/link/preview/:neid',
    name: 'linkfile',
    component: Linkpreviewbox,
  },
  // 外链页面,文件，文件夹
  // 暂定from = view
  {
    path: '/link/:from/:neid',
    name: 'link',
    component: Linkbox,
  },
  // 外链页面,文件，文件夹
  // 暂定from = view
  {
    path: '/thirdparty/:from/:neid',
    name: 'thirdparty',
    component: ThirdPartyLinkbox,
  },
  /*
   * 待审批单文件预览
  */
  {
    path: '/approve/:from/:taskId',
    name: 'approveFile',
    component: ApproveFile,
  },
  // 历史版本预览
  {
    path: '/preview/history/:neid/:nsid',
    name: 'version',
    component: Verbox,
  },
  // from= ent/self/search/recent/sharein/shareout 普通文件(夹)预览 带下拉列表
  {
    path: '/preview/:from/:neid/:nsid',
    name: 'file',
    component: Box,
  },
  {
    path: '/approve/preview/:from/:neid/:nsid',
    name: 'approveBox',
    component: ApproveBox,
  },

  // 预览相关vvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvvv
  // smartshare进的预览页面
  {
    path: '/preview/smartshare/:neid',
    name: 'smartshare',
    component: Smbox,
  },
  {
    path: '/link/user/prelogin/:neid',
    name: 'prelogin',
    component: PreLogin,
  },
  {
    path: '/ferry/:from/:taskId',
    name: 'ferry',
    component: FerryFile,
  },
]

if (process.env.NODE_ENV !== 'production') {
  // 图标字典
  routes.push({
    path: '/icondict',
    name: 'dict',
    component: Icondict,
  },
  { // 假登录
    path: '/login',
    name: 'login',
    component: Login,
  })
}

export default routes
